<template>
  <div id="app">
    <noscript><img src="https://vk.com/rtrg?p=VK-RTRG-494681-8uMab" style="position:fixed; left:-999px;" alt=""/></noscript>
    <div class="ef" ref="ef">
      <div class="ef__burger" @click="openMenu"></div>
      <transition name="slide-fade" mode="out-in">
        <div class="ef__mob-menu" v-if="mobMenu">
          <div class="ef__mob-menu-back" @click="closeMenu"></div>
          <div @click="closeMenu" style="border-top: 1px solid #444;"><router-link class="ef__mob-menu-link" active-class="_active" to="/tickets">Билеты</router-link></div>
          <div @click="closeMenu"><router-link class="ef__mob-menu-link" active-class="_active" to="/music">Музыка</router-link></div>
          <div @click="closeMenu"><router-link class="ef__mob-menu-link" active-class="_active" to="/about">О группе</router-link></div>
        </div>
      </transition>
      <div @click="closeMenu"><router-link class="ef-mob__logo" to="/"><span>East F. A. Q.</span></router-link></div>
      <div class="scope" ref="scope">
        <div class="scope__el"></div>
        <div class="scope__el"></div>
        <div class="scope__el"></div>
        <div class="scope__el"></div>
        <div class="scope__center" ref="scopeCenter">
          <div class="scope__center-line"></div>
          <div class="scope__center-line"></div>
        </div>
        <router-link class="scope__battery" to="/group">
          <span></span>
          <span></span>
        </router-link>
        <div class="scope__volume" 
             :class="{_muted: muted}" 
             ref="volume"
        >
          <img @click="toggleVol" src="./assets/img/volume.png" alt="">
          <span class="vol-track"><span class="vol-track__wrap"><span class="vol-track__vol"></span></span></span>
        </div>
        <div class="time">{{ time }}</div>
      </div>
      <div class="ef__background" ref="background"></div>
      <div class="ef__container" ref="content">
        <div class="ef__top">
          <div class="menu">
            <router-link class="menu__link" active-class="_active" to="/tickets"><span @click="getPositionLogo">Билеты</span></router-link>
            <router-link class="menu__link" active-class="_active" to="/music"><span @click="getPositionLogo">Музыка</span></router-link>
            <router-link class="menu__link" active-class="_active" to="/about"><span @click="getPositionLogo">О группе</span></router-link>
          </div>
          <a href="mailto:eastfaq@gmail.com" class="email">eastfaq@gmail.com</a>
        </div>
        <div class="ef__content">
          <transition name="fade" mode="out-in">
            <router-view :logoPosition="logoPosition" />
          </transition>
        </div>
      </div>
      <div class="video" ref="videoframe">
        <div class="video__bg"></div>
        <video loop muted ref="video">
        
        </video>
        <div class="video__rec"><span></span><img src="./assets/img/rec.png" alt=""></div>
      </div>
    </div>
    
  </div>

</template>


<script>
import { gsap } from 'gsap'

export default {
  name: 'App',

  data() {
    return {
      readyVideo: false,
      muted: true,
      time: '00 : 00 : 00',
      logoPosition: false,
      mobMenu: false,
      vol: 0.5
    }
  },

  computed: {
    volume() {
      return this.muted ? 0 : this.vol
    },
  },

  methods:{
    toggleVol() {
      let track = document.querySelector('.vol-track')
      let vol = track.querySelector('.vol-track__vol')
      if (this.muted) {
        this.editVol(null, track, vol, this.vol)
      } else {
        this.editVol(null, track, vol, 0)
      }
    },

    getPositionLogo() {
      this.logoPosition = true
    },

    openMenu() {
      this.mobMenu = true
    },

    closeMenu() {
      this.mobMenu = false
    },

    editVol(evt, track, vol, value) {
      if (value !== undefined) {
        let hTrack = track.offsetHeight
        let position = hTrack * (value * 100) / 100
        vol.style.height = position + 'px'

        if (value !== 0) {
          this.vol = value
          this.muted = false
          this.$refs.video.volume = this.vol
        } else {
          this.muted = true
          this.$refs.video.volume = 0
        }
      } else {
        let coordinates = track.getBoundingClientRect()
        let position = coordinates.bottom - evt.clientY
        let hTrack = track.offsetHeight

        if (position < 0) {
          position = 0
        } else if (position > hTrack) (
          position = hTrack
        )

        let volume = (position * 100 / hTrack) / 100

        vol.style.height = position + 'px'
        this.vol = volume

        if (volume) {
          this.muted = false
        } else {
          this.muted = true
        }
        
        this.$refs.video.volume = this.vol
      }
    }
  },

  mounted() {
    let self = this
    var now = new Date()
    let hours = now.getHours()
    let minutes = now.getMinutes()
    let seconds = now.getSeconds()
    self.time = hours + ' : ' + minutes + ' : ' + seconds

    setInterval(() => {
      seconds += 1

      if (seconds === 60) {
        seconds = 0
        minutes += 1
      }

      if (minutes === 60) {
        minutes = 0
        hours += 1
      }

      if (hours === 24) {
        hours = 0
        minutes = 0
        seconds = 0
      }

      self.time = formatedTime([hours, minutes, seconds])
    }, 1000)

    function formatedTime(arr) {
      let newarr = []

      arr.forEach((el) => {
        if (el < 10) {
          newarr.push('0' + el)
        } else {
          newarr.push(el)
        }
      })

      return newarr[0] + ' : ' + newarr[1] + ' : ' + newarr[2]
    }

    let video = document.querySelector('.video video')
    video.muted = false
    video.volume = this.volume
    video.addEventListener('canplaythrough', function () {
      setTimeout(() => {
        self.readyVideo = true
        video.play()
      }, 7000)
    }, false)

    let scope = this.$refs.scope
    let scopeCenter = this.$refs.scopeCenter
    let background = this.$refs.background
    let content = this.$refs.content
    let videoframe = this.$refs.videoframe
    let volume = this.$refs.volume

    const blurProperty = gsap.utils.checkPrefix("filter"),
            blurExp = /blur\((.+)?px\)/,
            getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

    gsap.registerPlugin({
        name: "blur",
        get(target) {
            return +(getBlurMatch(target)[1]) || 0;
        },
        init(target, endValue) {
            let data = this,
          filter = gsap.getProperty(target, blurProperty),
          endBlur = "blur(" + endValue + "px)",
          match = getBlurMatch(target)[0],
          index;
      if (filter === "none") {
        filter = "";
      }
      if (match) {
        index = filter.indexOf(match);
        endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
      } else {
        endValue = filter + endBlur;
        filter += filter ? " blur(0px)" : "blur(0px)";
      }
      data.target = target; 
      data.interp = gsap.utils.interpolate(filter, endValue); 
        },
        render(progress, data) {
            data.target.style[blurProperty] = data.interp(progress);
        }
    });

    if (window.innerWidth > 768) {
      gsap.from(scope, 1.5, {scale: 1.4, opacity: 0, easy: 'elastic'})
      gsap.from(background, 1.5, {blur: 1.5, scale: 1.02})
      gsap.to(scopeCenter, 0.5, {delay: 2})
      gsap.to(scopeCenter, 1, {delay: 3})
      gsap.to(background, 0.5, {delay: 2, x: -50, blur: 1.5, scale: 1.04})
      gsap.to(background, 0.5, {delay: 2.5, x: 50})
      gsap.to(background, 1, {delay: 3, y: 0, x: 0, blur: 0, scale: 1})
      gsap.set(content, {opacity: 0})
      gsap.to(content, 1, {delay: 4, opacity: 1})
      gsap.set(videoframe, {opacity: 0})
      gsap.to(videoframe, 2, {delay: 7, opacity: 1})
      gsap.set(volume, {opacity: 0})
      gsap.to(volume, 2, {delay: 7, opacity: 0.6})
      gsap.to(scopeCenter, 1, {delay: 7, opacity: 0})
    }

    let openTrack = false
    let activeTrack = false
    let track = document.querySelector('.vol-track')
    let vol = track.querySelector('.vol-track__vol')
    let scopeVolume = document.querySelector('.scope__volume')

    function onTrackMousemove(evt) {
      self.editVol(evt, track, vol)
    }

    function onTrackMousedown(evt) {
      document.addEventListener('mousemove', onTrackMousemove)
      document.addEventListener('mouseup', onTrackMouseup)
      self.editVol(evt, track, vol)
      activeTrack = true
    }

    function onTrackMouseup() {
      document.removeEventListener('mousemove', onTrackMousemove)
      document.removeEventListener('mouseup', onTrackMouseup)
      if (activeTrack) {
        activeTrack = false
        openTrack = false
        track.style.display = 'none'
        track.style.opacity = '0'
      }
    }

    track.addEventListener('mousedown', onTrackMousedown)

    track.addEventListener('mouseover', () => {
      track.style.display = 'block'
      track.style.opacity = '1'
      openTrack = true
    })

    scopeVolume.addEventListener('mouseover', () => {
      track.style.display = 'block'
      track.style.opacity = '1'
      openTrack = true
    })

    track.addEventListener('mouseout', () => {
      if (!activeTrack && openTrack) {
        openTrack = false
        track.style.display = 'none'
        track.style.opacity = '0'
      }
    })

    scopeVolume.addEventListener('mouseout', () => {
      if (!activeTrack && openTrack) {
        openTrack = false
        track.style.display = 'none'
        track.style.opacity = '0'
      }
    })
  }
}
</script>

<style lang="scss">
  $scope-width: 5px;

  body {
    padding: 0;
    margin: 0;
    background: #080808;
    color: #fff;
  }

  .ef-mob__logo {
    display: none;

    @media screen and (max-width: 768px) {
      display: block;
      position: absolute;
      right: 20px;
      top: 7px;
      z-index: 6;
      padding-top: 16px;
      font-family: Kungfont;
      color: #fff;
      font-size: 34px;
      text-align: center;
      text-decoration: none;
    }

    @media screen and (max-width: 480px) {
      font-size: 29px;
      padding-top: 20px;
    }
  }

  .ef {
    position: relative;
    height: 100vh;
    overflow: hidden;
    font-family: Helvetica, sans-serif;

    @media screen and (max-width: 768px) {
      height: auto;
      padding-bottom: 40px;
    }

    &__burger {
      display: none;

      @media screen and (max-width: 768px) {
        display: block;
        z-index: 5;
        position: absolute;
        left: 20px;
        top: 29px;
        width: 30px;
        height: 30px;
        background: url('./assets/img/burger.png') no-repeat center center;
        background-size: 100%;
      }
    }

    &__mob-menu {
      display: none;

      @media screen and (max-width: 768px) {
        z-index: 6;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        display: block;
        width: 100%;
        padding-top: 91px;
        background: rgba(0,0,0,0.9);
        box-sizing: border-box;
        transition: transform .5s;
      }
    }

    &__mob-menu-back {
      @media screen and (max-width: 768px) {
        position: absolute;
        left: 20px;
        top: 28px;
        width: 30px;
        height: 30px;
        background: #000;

        &:after {
          content: '';
          position: absolute;
          left: 14px;
          top: 0;
          display: block;
          width: 2px;
          height: 100%;
          background: #fff;
          transform: rotate(-45deg);
        }

        &:before {
          content: '';
          position: absolute;
          left: 14px;
          top: 0;
          display: block;
          width: 2px;
          height: 100%;
          background: #fff;
          transform: rotate(45deg);
        }
      }
    }

    &__mob-menu-link {
      @media screen and (max-width: 768px) {
        display: block;
        text-decoration: none;
        color: #fff;
        text-align: center;
        height: 40px;
        margin: 0 15px;
        line-height: 40px;
        border-bottom: 1px solid #444;
      }
    }

    &__background {
      z-index: 1;
      position: absolute;
      left: 60px;
      top: 0;
      right: 0;
      bottom: 0;
      background: #080808 url('./assets/img/1.jpg') no-repeat center top;
      background-size: auto 89%;

      @media screen and (max-width: 768px) {
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-size: 120%;
        opacity: .5;
      }
    }

    &__container {
      z-index: 3;
      position: relative;
      max-width: 1170px;
      height: 100%;
      margin: 0 auto;
      padding: 0 15px;

      @media screen and (max-width: 1480px) {
        max-width: 900px;
      }
      @media screen and (max-width: 1250px) {
        max-width: 700px;
      }
      @media screen and (max-width: 768px) {
        padding: 0 20px;
      }
    }

    &__top {
      display: flex;
      justify-content: space-between;
      padding-top: 64px;

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    &__content {
      padding-top: 30px;

      @media screen and (max-width: 768px) {
        padding-top: 100px;
      }
    }

    &__social {
      position: absolute;
      bottom: 10%;
      left: 15px;
    }

    &__social2 {
      position: absolute;
      bottom: 10%;
      right: 15px;
    }
  }

  .scope {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    @media screen and (max-width: 1100px) {
      display: none;
    }

    &__volume {
      position: absolute;
      right: 61px;
      padding-top: 10px;
      bottom: 55px;
      width: 50px;
      cursor: pointer;
      opacity: .6;
      transition: opacity .2s;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none;   /* Chrome/Safari/Opera */
      -khtml-user-select: none;    /* Konqueror */
      -moz-user-select: none;      /* Firefox */
      -ms-user-select: none;       /* Internet Explorer/Edge */
      user-select: none;           /* Non-prefixed version, currently
                                  not supported by any browser */

      &:hover {
        opacity: 1!important;
      }

      img {
        z-index: 2;
        position: relative;
        max-width: 100%;
        width: 80%;
      }

      &._muted {

        &:after {
          z-index: 1;
          content: '';
          position: absolute;
          left: 10px;
          top: 26px;
          display: block;
          width: 33px;
          height: 3px;
          background: #fff;
          transform: rotate(-45deg);
        }
      }
    }

    &__battery {
      position: absolute;
      top: 35px;
      right: 63px;
      display: block;
      width: 55px;
      height: 80px;
      background: url('./assets/img/battery.png') no-repeat center center;
      background-size: 100%;
      opacity: .6;
      transition: opacity .15s;

      &:hover {
        opacity: 1;
      }
      
      span {

        &:first-child {
          position: absolute;
          top: 31px;
          right: 5px;
          display: block;
          height: 19px;
          width: 11px;
          background: #fff;
        }

        &:last-child {
          position: absolute;
          top: 31px;
          right: 17px;
          display: block;
          height: 19px;
          width: 11px;
          background: #fff;
          animation: 'apulse' 2s infinite;
        }
      }
    }

    &__center {
      position: absolute;
      left: 50%;
      top: 50%;
      display: block;
      width: 300px;
      height: 150px;
      transform: translate(-50%, -50%);
      opacity: .5;
    }

    &__center-line {
      position: absolute;

      &:after, &:before {
        content: '';
        position: absolute;
        display: block;
        height: $scope-width / 2;;
        width: 40px;
        background: #fff;
      }

      &:first-child {
        left: 0;
        top: 0;
        bottom: 0;
        width: $scope-width / 2;
        background: #fff;

        &:after {
          left: 0;
          top: 0;
        }

        &:before {
          left: 0;
          bottom: 0;
        }
      }

      &:last-child {
        right: 0;
        top: 0;
        bottom: 0;
        width: $scope-width / 2;
        background: #fff;

        &:after {
          right: 0;
          top: 0;
        }

        &:before {
          right: 0;
          bottom: 0;
        }
      }
    }

    &__el {
      position: absolute;
      width: 150px;
      height: 150px;
      max-width: 6%;
      max-height: 10%;
      
      &:before {
        position: absolute;
        content: '';
        display: block;
        background: #a0a0a0;
      }
      
      &:after {
        position: absolute;
        content: '';
        display: block;
        background: #a0a0a0;
      }

      &:nth-child(1) {
        left: 40px;
        top: 40px;
        
        &:before {
          left: 0;
          top: 0;
          width: 100%;
          height: $scope-width;
        }
        
        &:after {
          left: 0;
          top: 0;
          width: $scope-width;
          height: 100%;
        }
      }

      &:nth-child(2) {
        right: 40px;
        top: 40px;
        
        &:before {
          right: 0;
          top: 0;
          width: 100%;
          height: $scope-width;
        }
        
        &:after {
          right: 0;
          top: 0;
          width: $scope-width;
          height: 100%;
        }
      }

      &:nth-child(3) {
        left: 40px;
        bottom: 40px;
        
        &:before {
          left: 0;
          bottom: 0;
          width: 100%;
          height: $scope-width;
        }
        
        &:after {
          left: 0;
          bottom: 0;
          width: $scope-width;
          height: 100%;
        }
      }

      &:nth-child(4) {
        right: 40px;
        bottom: 40px;
        
        &:before {
          right: 0;
          bottom: 0;
          width: 100%;
          height: $scope-width;
        }
        
        &:after {
          right: 0;
          bottom: 0;
          width: $scope-width;
          height: 100%;
        }
      }
    }
  }

  .menu {
    display: flex;
    padding: 0;
    margin: 0;
    font-family: Helvetica, sans-serif;
    font-size: 20px;
    letter-spacing: 1px;
    list-style-type: none;

    @media screen and (max-width: 768px) {
      display: none;
    }

    &__link {
      margin-right: 35px;
      color: #a0a0a0;
      text-decoration: none;
      transition: color .15s;

      &:hover {
        color: #fff
      }

      &._active {
        color: #fff;
      }
    }
  }

  .email {
    font-family: Helvetica, sans-serif;
    font-size: 20px;
    letter-spacing: 1px;
    color: #a0a0a0;
    text-decoration: none;
    transition: color .15s;

    @media screen and (max-width: 768px) {
      display: none;
    }

    &:hover {
      color: #fff
    }
  }

  .social {

    &__elem {
      margin-bottom: 20px;
      font-size: 0;
      opacity: .6;
      transition: opacity .15s;

      &:hover {
        opacity: 1;
      }

      &:first-child {
        margin-bottom: 35px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .video {
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    @media screen and (max-width: 768px) {
      display: none;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: none;
    }

    &__bg {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: #000;
      opacity: .7;
    }

    &__rec {
      position: absolute;
      left: 65px;
      top: 65px;
      width: 50px;
      padding-left: 21px;
      animation: 'apulse' 1.4s infinite;

      @media screen and (max-width: 1100px) {
        left: 20px;
        top: 20px;
      }

      img {
        max-width: 100%;
      }

      span {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 15px;
        height: 15px;
        background: #df0d0d;
        border-radius: 50%;
      }
    }
  }

  .time {
    position: absolute;
    bottom: 61px;
    left: 61px;
    color: #ccc;
    font-size: 21px;
  }

  .vol-track {
    position: absolute;
    left: 0;
    top: 0px;
    display: block;
    width: 50px;
    height: 80px;
    transform-origin: top;
    transform: rotate(180deg);
    opacity: 0;
    display: none;

    &__wrap {
      position: absolute;
      display: block;
      width: 7px;
      left: 50%;
      bottom: 0;
      height: 80px;
      background: rgba(255,255,255,0.2);
      border-radius: 2px;
      overflow: hidden;
    }

    &__vol {
      display: block;
      width: 100%;
      height: 0%;
      background: #fff;
    }
  }

  @keyframes apulse {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity .5s;
  }

  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-leave-to {
    opacity: 0;
  }

  .slide-fade-enter {
    transform: translateX(-100%);
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-leave-to {
    transform: translateX(-100%);
    opacity: 0;
  }
</style>
